export class NoteConfirmDeletionModal {
  static $inject = ['$mdDialog'];

  constructor(private $mdDialog) {}

  public show() {
    const confirm = this.$mdDialog
      .confirm()
      .title('Delete note?')
      .textContent('This note will be removed from the Student Profile Notes panel.')
      .ariaLabel('Confirm Note Deletion')
      .ok('DELETE')
      .cancel('CANCEL');

    return this.$mdDialog.show(confirm);
  }
}
